import script from "./ChatAnswerText.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatAnswerText.vue?vue&type=script&setup=true&lang=js"

import "./ChatAnswerText.vue?vue&type=style&index=0&id=baedc84a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-baedc84a"]])

export default __exports__